/**
 * Unwrap one `/alerts` page. Exported so the cursor → `truncated` mapping is
 * tested directly: every Overview test mocks `useAlertsList`, so without this
 * a broken mapping would pass the whole suite while the cards silently
 * undercounted again (#998 review M5).
 *
 * The envelope is {data: [...], cursor, error}. `resp.data ?? resp` also
 * accepts a bare array, in case a future worker change simplifies the shape.
 */
export function selectAlertsPage(resp, withMeta = false) {
  const raw = resp?.data ?? resp;
  const items = Array.isArray(raw) ? raw : [];
  return withMeta ? { items, truncated: Boolean(resp?.cursor) } : items;
}
